import React, { createElement } from "react";
import './BlockInterface.css';
import LoadingPage from '../LoadingPage/LoadingPage.js'
import { Module, SpacerModule, Heading1Module, Heading2Module, Heading3Module, ParagraphModule, MediaModule, FacebookModule } from "./Module";

const MODULE_TYPES = {
  SpacerModule: SpacerModule,
  Heading1Module: Heading1Module,
  Heading2Module: Heading2Module,
  Heading3Module: Heading3Module,
  ParagraphModule: ParagraphModule,
  MediaModule: MediaModule,
  FacebookModule: FacebookModule,
}
const NUM_ROW_CONTROLS = 2; //How many elements in each row that are not blocks (the buttons to move and delete).
const AUTOSCROLL_FPS = 30;

export default class BlockInterface extends React.Component {
  static num = 0;
  isDraggingRow = false;
  pageName = "";
  userPassword = "";

  state = {
    modules: null,//this contains the rows and the modules inside them.
    newModules: [],//"not real", just an place to originally append the module before they get moved to a row. [Not sent to server.]
    variables: null,
    isEditMode: false
  };

  constructor(props) {
    super();

    BlockInterface.num++;
    if (BlockInterface.num > 1) {
      throw new Error("Error: you can only have one block interface per page!");
    }

    this.pageName = props.pageName;
    this.mouseX = 0;
    this.mouseY = 0;
    
    this.loadModules()
      .then((jsonData) => this.createHTMLRows(this.createModules(jsonData)));
  }

  //Returns a promise to load modules from database.
  loadModules() {
    return new Promise((resolve, reject) => {
      fetch("/api/loadModules/" + this.pageName)
        .then((res) => res.json())
        .then((jsonData) => {
          resolve(jsonData);
        })
    });
  };

  //Takes in JSON data from DB and creates all the module components. They get stored in Module.moduleMap.
  createModules(jsonModules) {
    let modules = [];
    let numRows = 0;
    jsonModules.forEach(module => {
      modules.push(React.createElement(MODULE_TYPES[module.moduleType], { id: module.id, row: module.row, column: module.column, width: module.width, height: module.height, content: JSON.parse(module.content) }));
      if (module.row > numRows) { numRows = module.row; }
    });
    return [numRows, modules];
  }

  // Takes in an array of modules and numRows and organizes them into HTML row divs.
  createHTMLRows(numRowsAndModulesArr) {
    const modules = numRowsAndModulesArr[1];
    let rows = [];
    for (let i = 1; i <= numRowsAndModulesArr[0]; i++) {
      rows[i] = <div id={"row" + i} className="row" draggable={false} onDrop={(event) => this.drop(event)} onDragOver={(event) => this.dragOver(event)} onDragLeave={(event) => this.dragLeave(event)}>
        {modules.filter((module) => module.props.row === i).sort((a, b) => (a.props.column - b.props.column))}
        <div className={"rowGrabber"} draggable={window.matchMedia("only screen and (min-width: 768px)").matches} onDragStart={(event) => this.dragStart(event)} onDragEnd={(event) => this.dragEnd(event)}><img draggable={false} src="icons/reorder.png" /></div>
        <div className={"rowDeleteButton"} onClick={(event) => this.deleteRow(event.target.parentElement)}>&#x2715;</div>
      </div>;
    }
    this.setState({ modules: rows });
    return rows;
  }

  //Outputs the HTML of this component
  render() {
    return <div id="blockInterface" className={this.state.isEditMode ? "blockInterface editing" : "blockInterface"}>
      {!this.state.modules ? <LoadingPage /> : <div id="blockCanvas" className="blockCanvas" onDrop={(event) => this.blankDrop(event)} onDragOver={(event) => this.blankDragOver(event)} onDragLeave={(event) => this.blankDragLeave(event)}>
        {/* The module blocks. */}
        {this.state.modules}
      </div>}

      {/* Start/stop edit mode button.*/}
      {!this.state.modules ? "" :
        this.state.isEditMode ? <button class="editButton" onClick={() => this.endEdit()}> &#x1F4BE; </button> : <button class="editButton" onClick={() => this.startEdit()}> &#9998; </button>}
      {/* New module spawn zone (appears when in edit mode)*/}
      <div id="newModuleSpawnZone" className="newModuleSpawnZone">{this.state.newModules}</div>

      {/* Add module button (appears when in edit mode)*/}
      <div id={"addModuleButton"} className={"addModuleButton"}><img src="icons/add.png" />{this.createModuleTypeButtonsHTML()}</div>

      {/* Text toolbar (appears when editing text)*/}
      <div id={"textToolbar"} className={"textToolbar"}><center>
        <div id="boldButton" className="button" onMouseDown={(event) => Module.bold(event)}><b>B</b></div>
        <div id="italicButton" className="button" onMouseDown={(event) => Module.underline(event)}><u>U</u></div>
        <div id="underlineButton" className="button" onMouseDown={(event) => Module.italic(event)}>&#119868;</div>
        <div id="bulletButton" className="button" onMouseDown={(event) => Module.bullet(event)}>&#8226;-</div>
        <div className="spacer"></div>
        <div id="textAlignLeftButton" className="button" onMouseDown={(event) => Module.textAlign(event, "left")}><img src={"icons/align_left.png"} /></div>
        <div id="textAlignCenterButton" className="button" onMouseDown={(event) => Module.textAlign(event, "center")}><img src={"icons/align_center.png"} /></div>
        <div id="textAlignRightButton" className="button" onMouseDown={(event) => Module.textAlign(event, "right")}><img src={"icons/align_right.png"} /></div>
        <div id="textAlignJustifyButton" className="button" onMouseDown={(event) => Module.textAlign(event, "justify")}><img src={"icons/align_justify.png"} /></div>
        <div className="spacer"></div>
        <div id="linkButton" className="button" onMouseDown={(event) => Module.link(event)}><img src={"icons/link.png"} /></div>
      </center></div>
    </div>;
  }

  startEdit() {
    // this.beginEditMode(); //uncomments these two lines two bypass login (useful during development, but don't  make public)
    // return; 

    this.requestEditAccess()
      .then((resolve) => {
        if (resolve) {
          this.beginEditMode();
        }
      });
  }

  endEdit() {
    this.saveChanges()
      .then((resolve) => {
        if (resolve) {
          this.stopEditMode();
        }
      });
  }

  requestEditAccess() {
    return new Promise((resolve, reject) => {
      const userPassword = prompt("Please enter exec password:", this.userPassword);
      if (userPassword) {
        this.userPassword = userPassword;
        Module.userPassword = userPassword;
        fetch("/api/logIn", { method: "POST", body: JSON.stringify({ password: userPassword }), headers: { "Content-type": "application/json; charset=UTF-8" } })
          .then((res) => {
            if (res.status == 200) {
              resolve(true);
            }
            else {
              alert("Log-in failed :(");
              resolve(this.requestEditAccess());
            }
          });
      }
      else {
        resolve(false);
      }
    });
  }

  //Puts the website in edit mode
  beginEditMode() {
    this.setState({ isEditMode: true });
    Module.moduleMap.forEach(module => {
      module.setState({ canEdit: true });
    });
    document.addEventListener("dragover", (event) => this.updateMouseCoords(event));
    this.scrollInterval = setInterval(() => this.autoScroll(this.mouseY), 1000 / AUTOSCROLL_FPS);
  }

  //Stops edit mode and saves changes to database
  stopEditMode() {
    this.setState({ isEditMode: false });
    Module.moduleMap.forEach(module => {
      module.setState({ canEdit: false, wasEdited: false });
    });
    clearInterval(this.scrollInterval);
  }

  //saving to database
  saveChanges() {
    return new Promise((resolve, reject) => {
      //Sending data for modules to update and create (requires all the state data)
      let modulesToUpdate = [];
      Module.moduleMap.forEach(module => {
        if (module.state.wasEdited == true) {
          let dbInformation = {
            id: module.state.id.substring(5),
            moduleType: module.moduleType,
            row: module.state.row,
            column: module.state.column,
            width: module.state.width,
            height: module.state.height,
            content: module.state.content
          }
          modulesToUpdate.push(dbInformation);
        }
      });

      if (Module.deletedModuleIDs.length === 0 && modulesToUpdate.length === 0) {
        resolve(true);
        return;
      }

      fetch("/api/saveChanges", { method: "POST", body: JSON.stringify({ password: this.userPassword, pageName: this.pageName, moduleIDsDeleted: Module.deletedModuleIDs, modulesUpdated: modulesToUpdate }), headers: { "Content-type": "application/json; charset=UTF-8" } })
        .then((res) => {
          if (res.status == 200) {//All good, everything saved.
            alert("Changes saved! :)");
            resolve(true);
          }
          else if (res.status == 401) {//Wrong password
            alert("Log-in failed :(");
            this.requestEditAccess()
              .then((logInResolve) => {
                if (logInResolve) {
                  resolve(this.saveChanges());
                }
                else {
                  resolve(false);
                }
              });;
          }
          else {//Other error
            res.json().then((data) => console.error(data.error));
            if (window.confirm("Oops, something went wrong :(\nTry again?")) {
              resolve(this.saveChanges());
            }
            else {
              resolve(false);
            }
          }
        });
    });
  }

  updateMouseCoords(event){
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
  }

  //Row Dragging methods

  //Called by the grabber element being dragged.
  dragStart(event) {
    if (event.target.className != "rowGrabber") {
      return;
    }
    this.isDraggingRow = true;
    const row = event.target.parentElement;
    const rowNum = 1 * row.id.substring(3);

    event.dataTransfer.setDragImage(row, 0, row.offsetHeight / 2);
    event.dataTransfer.setData("rowNum", rowNum);

    setTimeout(function () { //Hiding the element needs a small delay so HTML doesn't think you dropped it.
      row.style.visibility = "hidden";
    }, 1);
  }

  //Called by element dropped on.
  drop(event) {
    event.preventDefault();
    if (!this.state.isEditMode) {//If not in edit mode, completely ignore.
      return;
    }
    else if (Module.isDraggingModule) {//If dragging a module, allow one to be placed in an empty row.
      let row = event.target;
      while (row.className != "row") {
        row = row.parentElement;
      }

      const children = Array.from(row.children);
      if (!(children.length < NUM_ROW_CONTROLS + 1 || (children.length == NUM_ROW_CONTROLS + 1 && children[0].className == "lineIndicator block"))) {
        return;
      }

      Module.drop(event);
    }
    else if (this.isDraggingRow) {//Regular row dragging.
      const rowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
      if (!rowLineIndicator) { return; }

      const oldRow = event.dataTransfer.getData("rowNum");
      const newRow = rowLineIndicator.getAttribute("row");

      //Shifting the rows:
      rowLineIndicator.after(document.getElementById("row" + oldRow));
      rowLineIndicator.remove();

      document.getElementById("row" + oldRow).style.visibility = "visible";

      //Update row numbers
      this.renumberRows();
    }
  }

  //Called by element being dragged.
  dragEnd(event) {
    const rowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
    if (rowLineIndicator) { rowLineIndicator.remove(); }

    this.isDraggingRow = false;
    const rowId = event.target.parentElement.id;
    document.getElementById(rowId).style.visibility = "visible";
  }

  //Called by element being dragged over.
  dragOver(event) {
    if (!this.state.isEditMode) {//If not in edit mode, completely ignore.
      return;
    }
    else if (Module.isDraggingModule) {//If dragging a module, allow one to be placed in an empty row.
      let row = event.target;
      while (row.className != "row") {
        row = row.parentElement;
      }

      const children = Array.from(row.children);
      if (!(children.length < NUM_ROW_CONTROLS + 1 || (children.length == NUM_ROW_CONTROLS + 1 && children[0].className == "lineIndicator block"))) {
        return;
      }

      event.preventDefault();
      const previousLineIndicator = document.getElementsByClassName("lineIndicator")[0];
      if (previousLineIndicator) { previousLineIndicator.remove(); }

      row.insertAdjacentHTML("afterbegin", "<div class=\"lineIndicator block\" row=\"" + row.id.substring(3) + "\" column=\"1\"></div>");
    }
    else if (this.isDraggingRow) {//Regular row dragging.
      event.preventDefault();
      const previousRowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
      if (previousRowLineIndicator) { previousRowLineIndicator.remove(); }

      let row = event.target;
      while (row.className != "row") {
        row = row.parentElement;
      }

      let placementPosition, newRow;
      if (event.clientY - row.getBoundingClientRect().top < row.clientHeight / 2) {//If on the top side of the row:
        placementPosition = "beforebegin";
        newRow = 1 * row.id.substring(3);
      }
      else {//If on the bottom side of the row: 
        placementPosition = "afterend";
        newRow = 1 * row.id.substring(3) + 1;
      }
      row.insertAdjacentHTML(placementPosition, "<div class=\"rowLineIndicator\" row=\"" + newRow + "\"></div>");
    }
  }

  //Called by element being dragged over.
  dragLeave() {
    const rowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
    if (rowLineIndicator) { rowLineIndicator.remove(); }

    const lineIndicator = document.getElementsByClassName("lineIndicator")[0];
    if (lineIndicator) { lineIndicator.remove(); }
  }



  // Blank (no rows) dragging functions
  blankDrop(event) {
    event.preventDefault();
    if (!this.state.isEditMode) {//If not in edit mode, completely ignore.
      return;
    }
    if (this.isDraggingRow && document.getElementById("blockCanvas").children.length == 1) {//When the user is dragging a row and there are no other rows.
      const rowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
      if (!rowLineIndicator) { return; }


      const oldRow = event.dataTransfer.getData("rowNum");
      const newRow = rowLineIndicator.getAttribute("row");

      //Shifting the rows:
      rowLineIndicator.after(document.getElementById("row" + oldRow));
      rowLineIndicator.remove();

      document.getElementById("row" + oldRow).style.visibility = "visible";

      //Update row numbers
      this.renumberRows();
    }
  }

  blankDragOver(event) {
    if (!this.state.isEditMode) {//If not in edit mode, completely ignore.
      return;
    }
    const blockCanvasChildren = document.getElementById("blockCanvas").children;
    if (this.isDraggingRow &&
      (blockCanvasChildren.length == 0 || blockCanvasChildren.length == 1 && blockCanvasChildren[0].className == "rowLineIndicator")) {//When the user is dragging a row and there are no other rows.
      event.preventDefault();
      const previousRowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
      if (previousRowLineIndicator) { previousRowLineIndicator.remove(); }

      document.getElementById("blockCanvas").insertAdjacentHTML("afterbegin", "<div class=\"rowLineIndicator\" row=\"1\"></div>");
    }
  }

  blankDragLeave() {
    const rowLineIndicator = document.getElementsByClassName("rowLineIndicator")[0];
    if (rowLineIndicator) { rowLineIndicator.remove(); }

    const lineIndicator = document.getElementsByClassName("lineIndicator")[0];
    if (lineIndicator) { lineIndicator.remove(); }
  }

  createModuleTypeButtonsHTML() {
    let buttons = [];
    for (let key in MODULE_TYPES) {
      buttons.push(<button onClick={(event) => {
        this.createNewModule(key)
      }}>{key.substring(0, key.length - 6)}</button>);
    }
    buttons.push(<button onClick={(event) => { this.createNewRow() }}>Row</button>);
    return buttons;
  }

  createNewModule(type) {
    const id = Module.generateNewIdNumber();

    let newModule = React.createElement(MODULE_TYPES[type], { id: id, row: 0, column: 0, canEdit: true });
    this.setState({ newModules: [...this.state.newModules, newModule] });
  }

  createNewRow() {
    this.setState({
      newModules: [...this.state.newModules,
      <div id={"row" + -1 * Math.random()} className="row" draggable={false} onDrop={(event) => this.drop(event)} onDragOver={(event) => this.dragOver(event)} onDragLeave={(event) => this.dragLeave(event)}>
        <div className={"rowGrabber"} draggable={window.matchMedia("only screen and (min-width: 768px)").matches} onDragStart={(event) => this.dragStart(event)} onDragEnd={(event) => this.dragEnd(event)}><img draggable={false} src="icons/reorder.png" /></div>
        <div className={"rowDeleteButton"} onClick={(event) => this.deleteRow(event.target.parentElement)}>&#x2715;</div>
      </div>]
    });
  }

  deleteRow(rowElement) {
    const rowNum = rowElement.id.substring(3);
    const children = Array.from(rowElement.children);

    for (let c = 0; c < children.length - 2; c++) {
      Module.moduleMap.get(children[c].id).delete();
    }
    rowElement.remove();
    this.renumberRows();
  }

  renumberRows() {
    const rows = Array.from(document.getElementById("blockCanvas").children);

    for (let r = 0; r < rows.length; r++) {
      const row = rows[r];
      if (row.id.substring(3) != r + 1) {
        row.id = "row" + (r + 1);
        Module.renumberModules(r + 1);
      }
    }
  }

  
  //Scroll up/down automatically while the user is dragging something.
  autoScroll(mouseY) {
    if (!(this.isDraggingRow || Module.isDraggingModule)) {
      return; //Not dragging anything
    }

    if (mouseY < 130) {
      window.scrollBy(0, -10);
    }
    else if (window.innerHeight - mouseY < 50) {
      window.scrollBy(0, 10);
    }
  }
}